import { province, city } from "./citymap";

export function changeCodeToCity(value: string) {
    if (!value) return "";
    if (typeof value !== "string") return "";
    const ar = value.split(",");
    if (!ar || ar.length === 0) return null;
    let prostr = "",
        citystr = "",
        cityArray = [];
    if (ar[0]) {
        for (const p of province) {
            if (p.value === ar[0]) {
                prostr = p.label;
                cityArray = city[ar[0]];
                break;
            }
        }
    }
    if (ar[1]) {
        for (const c of cityArray) {
            if (c.value === ar[1]) {
                citystr = c.label;
                break;
            }
        }
    }
    return `${prostr},${citystr}`;
}
